import React from 'react';
import { useFormContext } from 'react-hook-form';
import NextAction from '../../../OnBoardingDrawerAction/NextAction';

const EditPatientFormAction = ({
  isUpdating,
  btnText,
  testid
}: {
  isUpdating?: boolean;
  btnText?: string;
  testid?: string
}) => {
  const {
    formState: { isValid, isSubmitting, errors },
  } = useFormContext();

  return (
    <NextAction
      testid={testid ?? 'edit-patient-form-proceed'}
      disabled={!isValid || !!errors.height}
      type="submit"
      isSubmitting={isSubmitting || isUpdating}
      btnText={btnText}
    />
  );
};
export default EditPatientFormAction;
